var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_04_kreacje",
    "data-name": "04_kreacje",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(17.644 31.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4540",
    "data-name": "Path 4540",
    d: "M648.911,673.819a41.843,41.843,0,0,1-9.472,7.6L615.22,695.4a42.117,42.117,0,0,0,9.2-7.434c-22.726-51.88-59.218-78.481-86.293-63.472l23.962-13.834c27.115-15.657,63.952,10.951,86.819,63.162Z",
    transform: "translate(-528.199 -606.195)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4541",
    "data-name": "Path 4541",
    d: "M410.52,932.31c0-11.545-8.1-25.562-18.094-31.321s-18.074-1.1-18.074,10.438,8.088,25.549,18.074,31.308S410.52,943.842,410.52,932.31Zm30.025,17.352a42.117,42.117,0,0,1-9.2,7.434l-.263.155c-26.885,15.529-62.729-9.81-86.759-63.162a40.951,40.951,0,0,1,9.4-7.6l.527-.3c27.074-15.009,63.567,11.593,86.293,63.472Z",
    transform: "translate(-344.32 -867.893)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4542",
    "data-name": "Path 4542",
    d: "M1193.111,1537.61a10.737,10.737,0,0,1,4.868,8.406c0,3.106-2.181,4.361-4.868,2.815a10.763,10.763,0,0,1-4.861-8.42c0-3.092,2.181-4.361,4.861-2.8Z",
    transform: "translate(-1145.006 -1489.249)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 156,
    height: 156,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1c4c2b914680070fc7d0c9117ee63f51.svg";
export { ForwardRef as ReactComponent };